import { Pipe, PipeTransform } from '@angular/core';
import { IngredientChoice, OrderedItem } from 'ngx-web-api';
import { ChoiceIndexPipe } from './choice-index.pipe';

@Pipe({
  name: 'canMoveToStepChoice',
})
export class CanMoveToStepChoicePipe implements PipeTransform {
  choiceIndex = new ChoiceIndexPipe();

  transform(choice: IngredientChoice, choices: IngredientChoice[], visibleChoice: IngredientChoice, item: OrderedItem): boolean {
    if (Array.isArray(choices) && !!choice && !!visibleChoice && !!item) {
      const visibleChoiceIndex = this.choiceIndex.transform(choices, visibleChoice);
      const selectionChoiceIndex = this.choiceIndex.transform(choices, choice);
      return (
        selectionChoiceIndex < visibleChoiceIndex ||
        choices.filter((_v, i) => i >= visibleChoiceIndex && i < selectionChoiceIndex).every(c => this.isChoiceValid(c, item))
      );
    }

    return false;
  }

  isChoiceValid(choice: IngredientChoice, item: OrderedItem) {
    const orderedChoice = item.getChoice(choice.name);
    return !!orderedChoice && orderedChoice.isValid();
  }
}
